import React, { useEffect, useState } from "react";
import style from "./index.module.scss";
import { Menu, Breadcrumb, Form, Rate, Checkbox, Input, Button, message } from "antd";
import moment from "moment";

import tagIcon from "./icon_inline.png";
import "./common.css";
const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;
const { SubMenu } = Menu;
const { TextArea } = Input;
let _host = "";
let _loginHost = "";
const getUrlParam = (paraName: string) => {
  const url = document.location.toString();
  const arrObj = url.split("?");

  if (arrObj.length > 1) {
    const arrPara = arrObj[1].split("&");
    let arr;

    for (let i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");

      if (arr != null && arr[0] == paraName) {
        return arr[1];
      }
    }
    return "";
  } else {
    return "";
  }
};
export interface IAppProps {
  apiHost: string;
  proposalList: object[];
  moreProposalPlaceholder: string;
  loginHost: string;
}
const App: React.SFC<IAppProps> = (props) => {
  const { apiHost, proposalList, moreProposalPlaceholder, loginHost } = props;
  _host = apiHost;
  _loginHost = loginHost;
  const id = decodeURI(getUrlParam("listId"));
  const listId: any = id ? parseInt(id) : 716;

  const [menuList, setMenuList] = useState(null);
  const [userState, setUserState] = useState(0);
  /**
   *
   * 跳转登录页
   *
   */
  const jumpLoginUrl = () => {
    window.location.href = `${_loginHost}?ReturnUrl=` + encodeURIComponent(window.location.href);
  };

  /**
   *
   * 判断用户状态
   *
   */
  const getUserState = () => {
    fetch(`${_host}/docFeedback/userState?listId=${listId}&docType=1`, {
      credentials: "include",
    })
      .then((response) => response.json())
      .then((response) => {
        const { code, data } = response;
        if (code === 100000) {
          setUserState(data);
        }
      })
      .catch((err) => console.log(err));
  };

  /**
   *
   * 获取常用文档的相关信息
   *
   */
  const getDocDetail = () => {
    fetch(`${_host}/doc/getChannelInfoListByTreeId?id=${listId}`)
      .then((response) => response.json())
      .then((response) => {
        let _data;
        const { code, data } = response;
        if (code === 100000) _data = data;

        if (_data) setMenuList(_data);
      })
      .catch((err) => console.log(err));
  };

  /**
   *
   * 添加用户评分与反馈
   *
   */
  const addDocFeedBack = (values) => {
    const formParam = new FormData();

    Object.keys(values).forEach((key) => {
      const item = values[key];
      if (item) {
        if (Object.prototype.toString.call(item) === "[object Array]") {
          for (let i = 0; i < item.length; i++) formParam.append(`${key}[${i}]`, item[i]);
        } else {
          formParam.append(key, item);
        }
      }
    });
    const docType: any = 1;
    formParam.append("listId", listId);
    formParam.append("docType", docType);
    fetch(`${_host}/docFeedback/addDocumentFeedback`, {
      method: "POST",
      body: formParam,
      credentials: "include",
    })
      .then((response) => response.json())
      .then((response) => {
        const { code } = response;
        if (code === 100000) {
          message.success({
            content: "提交成功",
            duration: 3,
            onClose: () => {
              window.location.reload();
            },
            style: {
              marginTop: "50vh",
            },
          });
        } else if (code === 99999) {
          jumpLoginUrl();
          return;
        } else if (code === 600) {
          message.error({
            content: "网络异常，请重新提交",
            duration: 3,
            style: {
              marginTop: "50vh",
            },
          });
        }
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    getDocDetail();
    getUserState();
  }, [listId]);

  if (!menuList) return null;
  const { channelChain = [], josCmsChannel } = menuList || {};
  return (
    <section className={`${style.app}`}>
      <MenuContent
        menus={menuList || {}}
        selectKeys={channelChain && channelChain.map((o: any) => o.id.toString())}
        listId={listId}
      />

      <MainDetailContent
        contentList={channelChain || []}
        headerInfo={josCmsChannel || {}}
        userState={userState}
        proposalList={proposalList}
        moreProposalPlaceholder={moreProposalPlaceholder}
        addDocFeedBack={addDocFeedBack}
        jumpLoginUrl={jumpLoginUrl}
      />
    </section>
  );
};

export default App;

// 获取菜单
const getMenus = (list = []) => {
  if (!list) return [];
  return list.map((item) => {
    // 没有子元素，显示menuItem
    if (!item.childNodes || !item.childNodes.length) {
      return <Menu.Item key={item.id.toString()}>{item.channelName}</Menu.Item>;
    }
    return (
      <SubMenu key={item.id.toString()} title={item.channelName}>
        {getMenus(item.childNodes)}
      </SubMenu>
    );
  });
};

// 左侧 menu 菜单
const MenuContent = (props: any) => {
  const { menus: menuList, listId, selectKeys } = props;

  // 切换 左侧菜单
  const handleChangeMenu = (param: any) => {
    const selectId: number = parseInt(param.key, 10);
    if (selectId !== parseInt(listId, 10)) {
      const { origin, pathname } = window.location;
      window.location.href = `${origin + pathname}?listId=${selectId}`;
    }
  };

  return (
    <aside className={style.left_content}>
      <header className={style.title}>
        <img className={style.t_img} src={tagIcon} alt="" />
        常用文档
      </header>
      <section>
        <Menu selectedKeys={selectKeys} defaultOpenKeys={selectKeys} onClick={handleChangeMenu} mode="inline">
          {getMenus(menuList.josCmsChannels)}
        </Menu>
      </section>
    </aside>
  );
};

const MainDetailContent = (props: any) => {
  const { contentList, headerInfo } = props;
  if (!contentList || !contentList.length) return null;
  const { channelContent } = contentList[contentList.length - 1];

  return (
    <main className={style.right_content}>
      <header className={style.header_title}>
        <Breadcrumb>
          <Breadcrumb.Item>常用文档</Breadcrumb.Item>
          {contentList.map((o) => {
            return (
              <Breadcrumb.Item key={o.id}>
                <a href="">{o.channelName}</a>
              </Breadcrumb.Item>
            );
          })}
        </Breadcrumb>
      </header>

      <section className={style.main_doc_content}>
        <h1 className={style.title}>{headerInfo.channelName}</h1>
        <div className={style.time_desc}>更新时间：{moment(headerInfo.modified).format("YYYY-MM-DD HH:mm:ss")}</div>
        <div className="ck ck-content" dangerouslySetInnerHTML={{ __html: channelContent }} />
      </section>

      <DocScoreContent {...props}></DocScoreContent>
    </main>
  );
};

// 评分模块
const DocScoreContent = (props: any) => {
  const { userState, proposalList = [], moreProposalPlaceholder, addDocFeedBack, jumpLoginUrl } = props;
  const [form] = Form.useForm();

  /**
   *
   * 提交文档满意度评分
   *
   */

  const submitForm = (values) => {
    addDocFeedBack(values);
  };

  return (
    <div className={style.doc_score_wrap}>
      {userState === 0 ? (
        <div>
          请
          <a
            onClick={() => {
              jumpLoginUrl();
            }}
          >
            登录
          </a>
          后评价！
        </div>
      ) : null}
      {userState === 1 ? (
        <div className={style.set_score_wrap}>
          <Form form={form} layout="vertical" onFinish={submitForm}>
            <FormItem
              name="docSatisfaction"
              label="对此文档的满意度评分是："
              rules={[
                { required: true, message: "请进行评价" },
                {
                  pattern: new RegExp(/^[1-5]{1}$/, "g"),
                  message: "请进行评价",
                },
              ]}
            >
              <Rate className={style.rate_wrap}></Rate>
            </FormItem>
            <FormItem
              name="proposal"
              label="为了让我们更好的优化文档和改善服务，我们希望您能提出宝贵建议："
              rules={[{ required: true, message: "请勾选建议项" }]}
            >
              <CheckboxGroup className={style.proposal_wrap}>
                {proposalList &&
                  proposalList.map((item) => {
                    return (
                      <Checkbox key={item.value} value={item.value}>
                        {item.value}
                      </Checkbox>
                    );
                  })}
              </CheckboxGroup>
            </FormItem>
            <FormItem
              name="moreProposal"
              label={<span style={{ paddingLeft: "12px" }}>更多建议：</span>}
              rules={[{ required: false, message: "Please select your country!" }]}
            >
              <TextArea
                className={style.more_proposal_wrap}
                rows={4}
                showCount
                maxLength={500}
                placeholder={moreProposalPlaceholder}
              ></TextArea>
            </FormItem>
            <FormItem>
              <div className={style.submit_btn_wrap}>
                <Button type="primary" htmlType="submit">
                  提交
                </Button>
              </div>
            </FormItem>
          </Form>
        </div>
      ) : null}
      {userState === 2 ? (
        <div>
          <span className="color-blue">温馨提示：</span> 您当日评价次数已达上限，感谢您的建议！
        </div>
      ) : null}
    </div>
  );
};
